import { render } from "./ShowUser.vue?vue&type=template&id=fa468c0a&scoped=true"
import script from "./ShowUser.vue?vue&type=script&lang=js"
export * from "./ShowUser.vue?vue&type=script&lang=js"

import "./ShowUser.vue?vue&type=style&index=0&id=fa468c0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa468c0a"]])

export default __exports__